import { MutationHookOptions, useMutation } from '@apollo/client';

import { UpdateSavedSearchDocument, UpdateSavedSearchMutation, UpdateSavedSearchMutationVariables } 
  from './savedSearches.gql';

const defaultOptions = {} as const;

export function useUpdateSavedSearchMutation(
  baseOptions?: MutationHookOptions<
  UpdateSavedSearchMutation,
  UpdateSavedSearchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation<
  UpdateSavedSearchMutation,
  UpdateSavedSearchMutationVariables
  >(UpdateSavedSearchDocument, options);
}